import axios from "axios";

const fallbackBaseUrl = "https://placedrisk.com.au/";
const baseUrl = process.env.REACT_APP_BE_URL || fallbackBaseUrl;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

export default axiosInstance;
